/**
 * Convert a string to a URL-safe slug.
 *
 * @example
 * slugify('Hello World!') // 'hello-world'
 * slugify('  My Blog Post  ') // 'my-blog-post'
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
